<template>
  <div class="mobileheadersticky">
    <div class="row">
      <div class="col-2">
        <button
          class="navbar-toggler mobile-sidebar-toggler"
          type="button"
          id="mobileHeaderStickyBtn"
          @click.prevent="togglesidebar"
										data-test="mobileHeaderStickyBtn"
        >
          <div class="icon icon--ei-navicon icon--s">
            <!-- <img class="icon_cnt"
            src="@/assets/svg/ei-navicon.svg"
            alt
            srcset
            id="icon-count"> -->
            <svg id="mobileHeaderStickySvg"
                 class="icon_cnt"
                 xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 50 50"
																	data-test="mobileHeaderStickySvg"
            >
              <path d="M10 12h30v4H10z"></path>
              <path d="M10 22h30v4H10z"></path>
              <path d="M10 32h30v4H10z"></path>
            </svg>
          </div>
        </button>
      </div>
      <div class="col-8 p-0 m-0">
        <search></search>
      </div>
      <div class="col-2  wp_alignContent">
        <cart-button
          v-if="$route.path !== '/cart' &&
                          $route.path !== '/order-success' &&
                          !($route.query.token)">

        </cart-button>
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/widgets/search/Search'
import CartButton from '@/components/shared/widgets/CartButton'

export default {
	components: {
		Search,
		CartButton
	},
	methods: {
		mobilesticky () {
		},
		togglesidebar () {
			// eslint-disable-next-line quotes
			document.querySelector(".mobile-side-nav").classList.add("shown")
			$('#mainApp').addClass('backdrop')
		}
	},
	mounted () {
		window.onscroll = function () {
			const mobileStickyHeader = document.querySelector('.mobileheadersticky')
			const topHeaderMainContainer = document.querySelector('#topHeaderMainContainer')
			if (window.pageYOffset > 100 && mobileStickyHeader && topHeaderMainContainer) {
				document.querySelector('.mobileheadersticky').classList.add('sticky')
				document.querySelector('.mobileheadersticky').classList.add('sticky')
				document.querySelector('#topHeaderMainContainer').classList.remove('d-block')
				document.querySelector('#topHeaderMainContainer').classList.add('d-none')
			} else if (mobileStickyHeader && mobileStickyHeader.classList) {
				document.querySelector('.mobileheadersticky').classList.remove('sticky')
				document.querySelector('#topHeaderMainContainer').classList.remove('d-none')
				document.querySelector('#topHeaderMainContainer').classList.add('d-block')
			}
		}
	}
}
</script>

<style>
</style>
